import { Box } from "@material-ui/core";
import React from "react";
import { View, Text, ActivityIndicator } from "react-native";

type NotReceivedCountBoxProps = {
  notReceivedCount?: number;
};

/**tt
 * 未受領件数を表すコンポーネント
 * @param {{ notReceivedCount?: number }} props
 * @returns {React.ReactElement}
 */

const NotReceivedCountBox = ({
  notReceivedCount,
}: NotReceivedCountBoxProps) => {
  let content;

  const defaultStyle = {
    height: 25,
    width: 25,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    backgroundColor: "lightgray",
  };

  if (notReceivedCount === undefined) {
    content = (
      <ActivityIndicator size="small" color="grey" style={{ marginLeft: 5 }} />
    );
  } else if (notReceivedCount === 0) {
    content = <Box style={{ ...defaultStyle }}>{notReceivedCount}</Box>;
  } else if (notReceivedCount >= 0) {
    content = (
      <Box
        style={{ ...defaultStyle, backgroundColor: "#f44336", color: "white" }}
      >
        {notReceivedCount}
      </Box>
    );
  }

  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      <Text style={{ marginLeft: 5 }}>未受領件数：</Text>
      {content}
    </View>
  );
};

export default NotReceivedCountBox;
